<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Gönderilecek Mail Adresi</label>
            <input class="form-control" type="text" v-model="value.ToMailAddress" placeholder="Gönderilecek Mail Adresi"/>
        </div>
        <div class="col-12">
            <label class="form-label">Mail İçeriği</label>
        </div>
        <div class="col-12 mb-1">
            <is-bankasi-hgs-application-text-editor v-model="value"></is-bankasi-hgs-application-text-editor>
        </div>
        <div class="col-12">
            <v-file-uploader :accept="['pdf']" v-model="value" value-parameter="Attachment"></v-file-uploader>
        </div>

    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader'
import {BCard} from 'bootstrap-vue'
import IsBankasiHGSApplicationTextEditor from './IsBankasiHGSApplicationTextEditor.vue'

export default {
    props:{
        value:Object,
    },
    components:{
        VFileUploader,
        BCard,
        'is-bankasi-hgs-application-text-editor':IsBankasiHGSApplicationTextEditor
    },
}
</script>

<style>

</style>